module.exports = coreApis.spinQuery;